<h2 mat-dialog-title cdkDrag cdkDragHandle cdkDragRootElement=".cdk-overlay-pane">
    Loan Approval Script
</h2>
<mat-dialog-content>    
  <div  style="margin-bottom: 2em;" *ngIf="isSaha">
      <mat-card class="simple-card">
      <mat-card-content>
        <h3>Loan - SAHA</h3>
        <p><strong>BDM</strong></p>
        <p class="transform-sentence">
          "I wanted to share the great news! We have a conditional approval for you."    
        </p>
        <p><strong>Client</strong> : Great...</p>
        <p><strong>BDM</strong></p>
        <p class="transform-sentence">
            "At this time, you have been conditionally approved for  <strong>{{newLoanAmount | currency}}</strong>, 
            which includes our 3rd party services for obtaining your release letter, 
            updating the credit bureaus, providing monthly reporting to Equifax and access to the Credit Knowledge Enhancement Course. 
            These also cover the negotiation process and ensure that we can secure the best possible settlement for you."    
        </p>  
      </mat-card-content>
    </mat-card>
  </div>
  <div *ngIf = "isLpp">
      <mat-card class="simple-card">
      <mat-card-content>
        <h3>LPP - {{lppType}}</h3>
        <p><strong>BDM</strong></p>
        <p class="transform-sentence" *ngIf="lppType === 'Enhanced'; else standard">
            "Great news <strong>{{appName}}</strong>. Your loan has been approved. Your payment will be <strong>{{payment | currency}}</strong> per <strong>{{termType}}</strong> which includes our Optional Loan Protection Premium of <strong>{{lpp | currency}}</strong>. 
            The Optional Loan Protection Insurance could provide up to 6 monthly benefits in the case of Involuntary Unemployment, Total Disability, or a lump sum payment up to the outstanding amount remaining on your loan in the event of Death. 
            your first payment will be due on <strong>{{startDate | date:'MM/dd/yyyy'}}</strong>. IF CANCELLED WITHIN THE FIRST 30 DAYS, YOU CAN GET YOUR MONEY BACK FOR INSURANCE PREMIUMS PAID IN THAT TIME. 
            IF AFTER 30 DAYS, YOU WILL NOT RECEIVE A REFUND, BUT YOU ARE STILL FREE TO CANCEL AT ANY TIME. HOWEVER, TODAY WOULD BE THE ONLY OPPORTUNITY TO ENROLL AS IT CANNOT BE ADDED ON AFTER THE AGREEMENT 
            IS FINALIZED...
            Would you like to enroll in the program?"
        </p>  
        <ng-template #standard>
          <p class="transform-sentence">          
            “GREAT NEWS <strong>{{appName}}</strong>. YOUR LOAN HAS BEEN APPROVED. YOUR PAYMENT WILL BE <strong>{{payment | currency}}</strong> PER <strong>{{termType}}</strong> WHICH INCLUDES OUR OPTIONAL LOAN PROTECTION PREMIUM OF <strong>{{lpp | currency}}</strong>. 
            THE OPTIONAL LOAN PROTECTION INSURANCE COULD PROVIDE UP TO 6 MONTHLY BENEFITS IN THE CASE OF INVOLUNTARY UNEMPLOYMENT, INJURY OR SICKNESS, 
            OR A LUMP SUM PAYMENT UP TO THE OUTSTANDING AMOUNT REMAINING ON YOUR LOAN IN THE EVENT OF DEATH OR CRITICAL ILLNESS. 
            IN ADDITION, THE LOAN PROTECTION PROGRAM PROVIDES ADDITIONAL SUPPORT OF 3 MONTHLY PAYMENTS FOR UNPAID FAMILY LEAVE AND LIFETIME MILESTONES 
            INCLUDING GRADUATING FROM POST SECONDARY EDUCATION, RETIREMENT, HAVING A CHILD, ATTENDING APPRENTICE TRAINING AT A TRADES SCHOOL… 
            YOUR FIRST PAYMENT WILL BE DUE ON <strong>{{startDate | date:'MM/dd/yyyy'}}</strong>. IF CANCELLED WITHIN THE FIRST 30 DAYS, YOU CAN GET 
            YOUR MONEY BACK FOR INSURANCE PREMIUMS PAID IN THAT TIME. IF AFTER 30 DAYS, YOU WILL NOT RECEIVE A REFUND, BUT YOU ARE STILL FREE TO CANCEL 
            AT ANY TIME. HOWEVER, TODAY WOULD BE THE ONLY OPPORTUNITY TO ENROLL AS IT CANNOT BE ADDED ON AFTER THE AGREEMENT IS FINALIZED...
            WOULD YOU LIKE TO ENROLL IN THE PROGRAM?”
          </p>
        </ng-template>
      </mat-card-content>
    </mat-card>
  </div>
</mat-dialog-content>

<div class="modal-footer">         
    <mat-dialog-actions align="end">
        <button mat-raised-button color="primary" (click)="confirm()">Confirm</button>
        <button mat-raised-button color="warn" mat-dialog-close aria-label="Close dialog">Cancel</button>
    </mat-dialog-actions> 
</div>
